// extracted by mini-css-extract-plugin
export var text = "_4e-0";